import { css } from 'lit';

export const planeAvatarInputStyles = css`
  :host {
    display: flex;
    align-items: center;
    gap: var(--space-4);
    flex-wrap: wrap;
  }

  .preview {
    width: var(--avatar-size-lg);
    height: var(--avatar-size-lg);
    border-radius: var(--radius-round);
    border: var(--border-width) solid var(--border-strong);
    background: var(--surface-raised);
    object-fit: cover;
    display: grid;
    place-items: center;
    color: var(--text-muted);
    font-size: var(--font-size-2xl);
    font-weight: var(--font-weight-bold);
    overflow: hidden;
  }

  .controls {
    display: grid;
    gap: var(--space-2);
  }

  .buttons {
    display: flex;
    gap: var(--space-2);
  }

  input[type='file'] {
    display: none;
  }

  .problem {
    color: var(--tone-danger);
    font-size: var(--font-size-md);
  }
`;
